import { graphql } from 'gatsby'

import Layout from '../../../components/layout'
import Seo from '../../../components/seo'
import TextImageLeft from '../../../components/TextImages/TextImageLeft'
import Benefits from '../../../components/Benefits'
import Steps from '../../../components/Steps'
import BuyingHeroFilter from '../../../components/BuyingHero/BuyingHeroFilter'
import { TrustPilotCarousel } from '../../../components/TrustPilot/Trustbox'
import { CONTACT_ROUTE } from '../../../utils/routes/const'

const CatalogPage = ({ data }) => (
    <Layout bgColor='bg-white' footerColor='bg-gray'>
      <Seo title="Catalog " />
      <BuyingHeroFilter bgColorHero='bg-white' title='catalog.hero.title' />
      <div className='bg-gray'>
        <Benefits
          displayDescription={false}
          titleClass='mt-12 font-cirka text-xl lg:text-4xl text-black'
          type='buy'
          />
        <TextImageLeft
          description='buy.textimage.0.description'
          subtitle='buy.textimage.0.subtitle'
          title='buy.textimage.0.title'
          cta='buy.textimage.0.cta'
          image={data.textImage}
          url={CONTACT_ROUTE}
          imgWrapperClass='mt-8 lg:mt-0 flex-shrink-0 flex lg:w-5/12'
          textWrapperClass='lg:w-4/12 pr-16'
          withTrustLogo
          />
        <Steps />
        <TrustPilotCarousel />
      </div>
    </Layout>
  )

export default CatalogPage

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    textImage: file(base: {eq: "textimageBuy.jpg"}) {
      base
      childImageSharp {
        gatsbyImageData(
          avifOptions: {lossless: true}
        )
      }
  	}
  }
`
